import React, { useEffect } from 'react';

const SRC = 'https://api.resellerratings.com/assets/script/c913dbc11229f2a396be678b4d76aaf79';

/**
 * The ResellerRatings mini seal, from
 * `domain-overrides/magzoom.com/includes/widgets/reseller_ratings/seal.html`.
 *
 * Not `shared/components/ResellerRatingsBadge`, and not TopMags' either: both of those
 * are an `<img>` for a known seller id, and MagZoom's seal is not one. Its script builds
 * a small React app of its own — the star strip and the review count — into
 * `#minisealfooter`, and the seller is baked into the script url rather than passed to
 * it, so there is no id here to hand a shared component.
 *
 * The script is injected in an effect rather than written as JSX, which is the same
 * reason CompanyReviewScript does it: React DOM creates script elements through a
 * detached div, which sets their parser-inserted flag and stops them ever executing.
 * Doing it in an effect also keeps it out of the server render, so the markup the SSR
 * cache holds is the empty container and hydration has nothing to disagree about.
 *
 * The container is rendered with no children and never given any, so React has nothing
 * to reconcile inside it once the vendor has taken it over.
 */
export default function ResellerRatingsBadge() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SRC}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;

    document.body.appendChild(script);
  }, []);

  return <div id="minisealfooter" />;
}
